import { Controller } from "@hotwired/stimulus";

const TIME_PATTERN = /^(\d{1,2}):(\d{2})\s*(AM|PM)$/i;
const ACTIVE_CLASSES = ["bg-white", "shadow-sm", "font-semibold", "text-slate-800"];
const INACTIVE_CLASSES = ["text-slate-500"];

export default class extends Controller {
  static targets = ["value", "hour", "minute", "meridiem"];

  connect() {
    const match = this.valueTarget.value.match(TIME_PATTERN);
    this.meridiem = match ? match[3].toUpperCase() : "AM";
  }

  limit(event) {
    const field = event.currentTarget;
    const digits = field.value.replace(/\D/g, "").slice(0, 2);
    const max = parseInt(field.dataset.max, 10);

    field.value = digits && parseInt(digits, 10) > max ? String(max) : digits;
    this.update();
  }

  format() {
    if (this.hourTarget.value === "0" || this.hourTarget.value === "00") this.hourTarget.value = "";
    if (this.hourTarget.value) this.minuteTarget.value = this.minuteTarget.value.padStart(2, "0");
    this.update();
  }

  selectMeridiem(event) {
    this.meridiem = event.currentTarget.dataset.meridiem;
    this.meridiemTargets.forEach((button) => {
      const active = button.dataset.meridiem === this.meridiem;
      ACTIVE_CLASSES.forEach((name) => button.classList.toggle(name, active));
      INACTIVE_CLASSES.forEach((name) => button.classList.toggle(name, !active));
    });
    this.update();
  }

  update() {
    const hour = parseInt(this.hourTarget.value, 10);
    const minute = parseInt(this.minuteTarget.value || "0", 10);

    this.valueTarget.value = hour ? `${this.pad(hour)}:${this.pad(minute)} ${this.meridiem}` : "";
  }

  pad(value) {
    return String(value).padStart(2, "0");
  }
}
